import * as React from 'react'
import { Button } from '..'
import { Apple } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const AppleButton = ({ children, onClick, className, disabled }) => {
  const s = useStyle()
  return (
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={<Apple />}
      className={clsx(s.button, className)}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}

const useStyle = makeStyles({
  button: {
    backgroundColor: '#000',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#ddd',
    },
    textTransform: 'none',
  },
})

export default AppleButton
